import { render, staticRenderFns } from "./OffsetByPlate.vue?vue&type=template&id=732273cb"
import script from "./OffsetByPlate.vue?vue&type=script&lang=js"
export * from "./OffsetByPlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports